import { ApiSchema } from "@api-types";
import { combineLatest, of } from "rxjs";
import { filter, map } from "rxjs";
import { getUserService } from "services/user.service";

export const hasPolicy$ = (policy: ApiSchema.Policy) =>
  getUserService().policies$.pipe(
    map((policies) => policies.includes(policy)),
    filter((e) => typeof e === "boolean"),
  );

export const hasAnyPolicy$ = (policies: ApiSchema.Policy[]) =>
  policies.length === 0
    ? of(true)
    : combineLatest(policies.map((policy) => hasPolicy$(policy))).pipe(
        map((results) => results.some(Boolean)),
        filter((e) => typeof e === "boolean"),
      );
